import { useTranslation } from 'react-i18next';

import { SettingsList } from '@/components/settings/SettingsList';

/**
 * Impostazioni — l'elenco delle sotto-schermate, più il logout.
 *
 * L'elenco vero sta in `SettingsList`, condiviso con la tasca Impostazioni
 * dello Zaino: le due superfici mostrano le stesse voci, e devono restare le
 * stesse anche fra sei mesi. Qui resta solo il titolo, che è l'unica cosa che
 * cambia fra i due posti.
 */
export function SettingsHome() {
  // ⚠️ Il padding in basso e' `max(1.5rem, var(--ingombro-flottante, 0px))`: col bottone flottante dei minigiochi montato l'ultima voce («Esci»)
  // scorre sopra di lui invece di restargli sotto; senza il bottone la variabile non c'e' e il padding e' 1.5rem, come prima (tma-orcr-100).
  const { t } = useTranslation('general');

  return (
    <div className="flex flex-col gap-6 px-4 pb-[max(1.5rem,var(--ingombro-flottante,0px))] pt-5">
      {/* I-318, ADR-0190 §1: titolo di sezione fuori dalla vista, `sr-only`; la chiave resta in uso. */}
      <header className="sr-only">
        <h1>
          {t('settings', { defaultValue: 'Settings' })}
        </h1>
      </header>

      <SettingsList conStudio conSonda />
    </div>
  );
}
